import moment from "moment";
import React from "react";
import { Col, Row } from "react-bootstrap";

const OverViewColumns = ({
  data = {},
  numRows = [],
  emailRows = [],
  priceFields = [],
  dateFields = [],
  dateTimeFields = [],
  fieldsToShow = [],
  md = 4,
  mt = 1,
  className = "",
  fontSize = "midFont",
  compact,
}) => {
  const getValue = (key, isObject, objectKey) => {
    const value = isObject ? data[key]?.[objectKey] : data[key];
    if (typeof value !== "boolean" && value !== 0 && !value) return "N/A";

    if (emailRows.includes(key)) {
      return (
        <a
          onClick={(e) => e.stopPropagation()}
          className="text-secondary"
          href={`mailto:${value}`}
        >
          {value}
        </a>
      );
    }

    if (numRows.includes(key)) {
      return (
        <a
          onClick={(e) => e.stopPropagation()}
          className="text-secondary"
          href={`tel:${value}`}
        >
          {value}
        </a>
      );
    }
    if (dateFields.includes(key)) {
      return moment(value).format("MMMM Do, YYYY");
    }
    if (dateTimeFields.includes(key)) {
      return moment(value).format("MMMM Do, YYYY hh:mm a");
    }

    if (priceFields.includes(key)) {
      return `$${value}`;
    }
    return Array.isArray(value) ? value.join(", ") : value;
  };

  return (
    <Row className={className}>
      {fieldsToShow.map((field) => {
        const key = typeof field !== "string" ? field.key : field;
        const label = typeof field !== "string" ? field.label : field;

        return (
          <Col xs={12} md={md} className={`mt-${mt} px-2 ${fontSize}`}>
            <p className="mb-0 text-dark ">
              <span className="text-muted mid">{label}: </span>
            </p>
            <p className="mb-0  text-dark px-2 py-1 large bg-primary-light rounded">
              {data[key]
                ? getValue(key, field.isObject, field.objectKey)
                : "N/A"}
            </p>
          </Col>
        );
      })}
    </Row>
  );
};

export default OverViewColumns;
